let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9u8bR")).then(() => parcelRequire('5w2FB'));